import image0 from './images/schody24 - schody drewniane lakierowane z podestem.jpg';
import image1 from './images/schody51 - schody drewniane czarne z oswietleniem pod stopniami.jpg';
import image2 from './images/schody14 - schody drewniane zabiegowe nakladane.jpg';
import image3 from './images/schody32 - schody drewniane zabiegowe.jpg';
import image4 from './images/schody23 - schody drewniane lakierowane z podestem.jpg';
import image5 from './images/schody43 - schody drewniane nakladane.jpg';
import image6 from './images/schody41 - schody drewniane nakladane.jpg';
import image7 from './images/schody33 - schody drewniane zabiegowe.jpg';
import image8 from './images/schody31 - schody drewniane zabiegowe.jpg';
import image9 from './images/schody44 - schody drewniane nakladane.jpg';
import image10 from './images/schody21 - schody drewniane lakierowane z podestem.jpg';
import image11 from './images/schody52 - schody drewniane czarne z oswietleniem pod stopniami.jpg';
import image12 from './images/schody61 - schody drewniane zabiegowe do garazu.jpg';
import image13 from './images/schody12 - schody drewniane zabiegowe nakladane.jpg';
import image14 from './images/schody15 - schody drewniane zabiegowe nakladane.jpg';
import image15 from './images/schody22 - schody drewniane lakierowane z podestem.jpg';
import image16 from './images/schody62 - schody drewniane zabiegowe do garazu.jpg';
import image17 from './images/schody16 - schody drewniane zabiegowe nakladane.jpg';
import image18 from './images/schody11 - schody drewniane zabiegowe nakladane.jpg';
import image19 from './images/schody13 - schody drewniane zabiegowe nakladane.jpg';
import image20 from './images/schody42 - schody drewniane nakladane.jpg';
import image21 from './images/schody53 - schody drewniane czarne z oswietleniem pod stopniami.jpg';

import imageThumb0 from './thumbImages/schody24 - schody drewniane lakierowane z podestem.jpg';
import imageThumb1 from './thumbImages/schody51 - schody drewniane czarne z oswietleniem pod stopniami.jpg';
import imageThumb2 from './thumbImages/schody14 - schody drewniane zabiegowe nakladane.jpg';
import imageThumb3 from './thumbImages/schody32 - schody drewniane zabiegowe.jpg';
import imageThumb4 from './thumbImages/schody23 - schody drewniane lakierowane z podestem.jpg';
import imageThumb5 from './thumbImages/schody43 - schody drewniane nakladane.jpg';
import imageThumb6 from './thumbImages/schody41 - schody drewniane nakladane.jpg';
import imageThumb7 from './thumbImages/schody33 - schody drewniane zabiegowe.jpg';
import imageThumb8 from './thumbImages/schody31 - schody drewniane zabiegowe.jpg';
import imageThumb9 from './thumbImages/schody44 - schody drewniane nakladane.jpg';
import imageThumb10 from './thumbImages/schody21 - schody drewniane lakierowane z podestem.jpg';
import imageThumb11 from './thumbImages/schody52 - schody drewniane czarne z oswietleniem pod stopniami.jpg';
import imageThumb12 from './thumbImages/schody61 - schody drewniane zabiegowe do garazu.jpg';
import imageThumb13 from './thumbImages/schody12 - schody drewniane zabiegowe nakladane.jpg';
import imageThumb14 from './thumbImages/schody15 - schody drewniane zabiegowe nakladane.jpg';
import imageThumb15 from './thumbImages/schody22 - schody drewniane lakierowane z podestem.jpg';
import imageThumb16 from './thumbImages/schody62 - schody drewniane zabiegowe do garazu.jpg';
import imageThumb17 from './thumbImages/schody16 - schody drewniane zabiegowe nakladane.jpg';
import imageThumb18 from './thumbImages/schody11 - schody drewniane zabiegowe nakladane.jpg';
import imageThumb19 from './thumbImages/schody13 - schody drewniane zabiegowe nakladane.jpg';
import imageThumb20 from './thumbImages/schody42 - schody drewniane nakladane.jpg';
import imageThumb21 from './thumbImages/schody53 - schody drewniane czarne z oswietleniem pod stopniami.jpg';

const GalleryImages = [
  { id: 0, img: image0, imgThumb: imageThumb0 },
  { id: 1, img: image1, imgThumb: imageThumb1 },
  { id: 2, img: image2, imgThumb: imageThumb2 },
  { id: 3, img: image3, imgThumb: imageThumb3 },
  { id: 4, img: image4, imgThumb: imageThumb4 },
  { id: 5, img: image5, imgThumb: imageThumb5 },
  { id: 6, img: image6, imgThumb: imageThumb6 },
  { id: 7, img: image7, imgThumb: imageThumb7 },
  { id: 8, img: image8, imgThumb: imageThumb8 },
  { id: 9, img: image9, imgThumb: imageThumb9 },
  { id: 10, img: image10, imgThumb: imageThumb10 },
  { id: 11, img: image11, imgThumb: imageThumb11 },
  { id: 12, img: image12, imgThumb: imageThumb12 },
  { id: 13, img: image13, imgThumb: imageThumb13 },
  { id: 14, img: image14, imgThumb: imageThumb14 },
  { id: 15, img: image15, imgThumb: imageThumb15 },
  { id: 16, img: image16, imgThumb: imageThumb16 },
  { id: 17, img: image17, imgThumb: imageThumb17 },
  { id: 18, img: image18, imgThumb: imageThumb18 },
  { id: 19, img: image19, imgThumb: imageThumb19 },
  { id: 20, img: image20, imgThumb: imageThumb20 },
  { id: 21, img: image21, imgThumb: imageThumb21 },
];

export default GalleryImages;
